module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/point_photowedding_02@3x-66b0ec32ebfc509ddef011be57193636.webp";